'use strict';

import * as util from '../util/Common.js';
import {Point2D} from '../util/Geometry.js';
import {EventManager} from '../util/EventManager.js';
import * as domUtil from '../util/Dom.js';

const privateMap = util.createPrivateMapper();

export class PlaybackDisposition {
  constructor(){
    this.playing = false;
  }
}

export class PlaybackContentControl extends EventManager {
  constructor(){
    super();
    const pv = privateMap(this);
    pv.playing = false;
    pv.currentTime = 0;
    pv.duration = 0;

    pv.listeners = {};
    pv.listeners['play'] = (ev) => {
      pv.playing = true;
      this.dispatchEvent('play');
    };
    pv.listeners['pause'] = (ev) => {
      pv.playing = false;
      this.dispatchEvent('pause');
    };
    pv.listeners['playing'] = (ev) => {
      pv.playing = true;
    };
    pv.listeners['ended'] = (ev) => {
      pv.playing = false;
      this.dispatchEvent('pause');
    };
    pv.listeners['seeking'] = (ev) => {
      this.dispatchEvent('seeking');
    };
    pv.listeners['seeked'] = (ev) => {
      this.dispatchEvent('seeked');
    };
    pv.listeners['timeupdate'] = (ev) => {
      pv.currentTime = pv.playbackTarget.currentTime;
      this.dispatchEvent('timeupdate');
    };

    pv.disposition = new PlaybackDisposition();
  }
  get disposition(){
    return privateMap(this).disposition;
  }
  set resource(resource){
    super.resource = resource;
    const pv = privateMap(this);
    const listeners = pv.listeners;
    if (pv.playbackTarget) {
      pv.playbackTarget.pause();
      for (let k in listeners) {
        domUtil.removeEventListener(pv.playbackTarget, k, listeners[k]);
      }
    }
    pv.playbackTarget = null;
    if (resource) {
      pv.playbackTarget = resource.playbackTarget;
      pv.duration = resource.duration;
      for (let k in listeners) {
        domUtil.addEventListener(pv.playbackTarget, k, listeners[k]);
      }
    }
  }

  get playing(){
    return privateMap(this).playing;
  }

  get currentTime(){
    return privateMap(this).currentTime;
  }

  get duration(){
    return privateMap(this).duration;
  }

  seek(time){
    const playbackTarget = privateMap(this).playbackTarget;
    if (!playbackTarget) {
      return;
    }
    if (typeof(time) != 'number') {
      return;
    }
    playbackTarget.currentTime = time;
  }
  play(){
    const playbackTarget = privateMap(this).playbackTarget;
    if (!playbackTarget) {
      return;
    }
    playbackTarget.play();
  }
  pause(){
    const playbackTarget = privateMap(this).playbackTarget;
    if (!playbackTarget) {
      return;
    }
    playbackTarget.pause();
  }
  stop(){
    const playbackTarget = privateMap(this).playbackTarget;
    if (!playbackTarget) {
      return;
    }
    playbackTarget.currentTime = 0;
    playbackTarget.pause();
  }
}
